"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_web_components_1 = require("@nimles/react-web-components");

var react_1 = __importStar(require("react"));

var react_redux_1 = require("react-redux");

var react_redux_2 = require("@nimles/react-redux");

var styled_1 = __importDefault(require("@emotion/styled"));

var react_web_components_2 = require("@nimles/react-web-components");

var Link_1 = require("./Link");

var Name = styled_1.default.h2(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 16px;\n  margin-top: 0;\n  font-size: 500;\n  flex: 1 0 auto;\n"], ["\n  font-size: 16px;\n  margin-top: 0;\n  font-size: 500;\n  flex: 1 0 auto;\n"])));
var CardLink = styled_1.default(Link_1.NavLink)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex: 1 0 auto;\n  display: flex;\n  flex-direction: column;\n"], ["\n  flex: 1 0 auto;\n  display: flex;\n  flex-direction: column;\n"]))); // interface Props {
//   organizationId: string;
//   productGroupId: string;
//   start: number;
//   limit: number;
//   order: string;
// }

exports.ProductList = function (_a) {
  var organizationId = _a.organizationId,
      productGroupId = _a.productGroupId,
      _b = _a.start,
      start = _b === void 0 ? 0 : _b,
      _c = _a.limit,
      limit = _c === void 0 ? 24 : _c,
      _d = _a.order,
      order = _d === void 0 ? 'name' : _d;
  var dispatch = react_redux_1.useDispatch();
  var products = react_redux_1.useSelector(function (_a) {
    var publicProducts = _a.publicProducts;
    return publicProducts.values;
  });
  var tenant = react_redux_1.useSelector(function (_a) {
    var publicTenants = _a.publicTenants;
    return publicTenants.selected;
  });
  react_1.useEffect(function () {
    dispatch(react_redux_2.searchAndLoadPublicProducts({
      start: start,
      limit: limit,
      order: order,
      organizationId: organizationId,
      productGroupIds: productGroupId
    }));
  }, [start, limit, order, organizationId, productGroupId]);
  return react_1.default.createElement(react_web_components_1.Row, {
    wrap: true
  }, products.map(function (product) {
    return react_1.default.createElement(react_web_components_1.Column, {
      key: product.id,
      padding: true,
      xs: 100,
      md: 50,
      lg: 33,
      xl: 25
    }, react_1.default.createElement(react_web_components_1.Card, {
      flex: "1 0 auto"
    }, react_1.default.createElement(CardLink, {
      to: "/" + product.uniqueName + "/pr"
    }, react_1.default.createElement(react_web_components_2.Image, {
      src: "https://media.nimles.com/file/" + tenant.id + "/" + product.images[0].id + "?width=200",
      alt: product.name
    }), react_1.default.createElement(react_web_components_1.CardBody, null, react_1.default.createElement(Name, null, product.name), react_1.default.createElement(react_web_components_2.Price, null, product.netPrice)))));
  }));
};

var templateObject_1, templateObject_2;